import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const reportsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMovementsReport: builder.query({
      query: ({ page, limitNumber, params, paginated = true }) => {
        return paginated
          ? {
              url: `/reports/movements/${page}/params`,
              params: { limitNumber, ...removeEmptyKeys(params) },
            }
          : {
              url: `/reports/movements`,
              params: { ...removeEmptyKeys(params) },
            }
      },
      providesTags: ['reports'],
    }),
    getBalanceReport: builder.query({
      query: ({ page, limitNumber, params, paginated = true }) => {
        return {
          url: `/reports/balance/${page}/params`,
          params: { limitNumber, ...removeEmptyKeys(params) },
        }
      },
      //providesTags: ['balance'],
    }),
    getStudentsReport: builder.query({
      query: ({ params = {} }) => {
        return {
          url: `/reports/students`,
          params: { ...removeEmptyKeys(params) },
        }
      },
    }),
    getASLGeneralReport: builder.query({
      query: () => {
        return {
          url: `/reports/general`,
        }
      },
    }),
    getBlockChainASL: builder.query({
      query: ({ params }) => {
        return {
          url: `reports/blockchainbalance`,
          params: { ...removeEmptyKeys(params) },
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const {
  useGetASLGeneralReportQuery,
  useLazyGetASLGeneralReportQuery,
  useGetStudentsReportQuery,
  useLazyGetStudentsReportQuery,
  useGetMovementsReportQuery,
  useLazyGetMovementsReportQuery,
  useGetBalanceReportQuery,
  useLazyGetBalanceReportQuery,
  useGetBlockChainASLQuery,
} = reportsApiSlice

export const { getBalanceReport } =
  reportsApiSlice.endpoints
